// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import moment from 'moment';
import { get } from 'lodash/fp';

import Responsive from 'app/components/responsive/Responsive';

type Props = {
  data: Object
};

const Wrapper = styled.div(({ theme }) => ({
  padding: theme.spacing.small
}));

const LabelValue = styled.span(({ theme }) => ({
  fontSize: theme.fontSize.xsmall
}));

const Comment = styled(LabelValue)({
  color: 'pink'
});

const StatsLabel = styled.div(({ theme }) => ({
  color: theme.color.basis4,
  fontSize: theme.fontSize.xsmall,
  fontWeight: theme.fontWeight.demiBold
}));

const TableHeader = styled.div(({ theme }) => ({
  backgroundColor: '#f2f2f2',
  borderColor: theme.color.white,
  fontSize: theme.fontSize.xsmall,
  padding: theme.spacing.tiny,
  fontWeight: theme.fontWeight.demiBold,
  height: '50%',
  textAlign: 'center'
}));

const TableValue = styled.div(({ theme }) => ({
  padding: theme.spacing.tiny,
  fontSize: theme.fontSize.xsmall,
  textAlign: 'center'
}));

const playerInfo = [
  {
    label: 'Age',
    key: 'foaling_date'
  },
  {
    label: 'Sex',
    key: 'sex'
  },
  {
    label: 'Col',
    key: 'color'
  },
  {
    label: 'Dam',
    key: 'dam'
  },
  {
    label: 'Sire',
    key: 'sire'
  }
];

const RacingOverview: React.FC<Props> = ({
  data: { player = {}, stats = {}, rider = {}, trainer = {} } = {}
}: Props) => {
  return (
    <Wrapper>
      {!!player.comment && (
        <div className="columns">
          <div className="column is-full">
            <StatsLabel>Runner Comments</StatsLabel>
            <Comment>{player.comment}</Comment>
          </div>
        </div>
      )}
      <div className="columns is-mobile is-multiline">
        <div className="column is-3-desktop is-3-tablet is-4-mobile">
          <StatsLabel>Jockey</StatsLabel>
          <LabelValue>{get('name', rider) || '-'}</LabelValue>
        </div>
        <div className="column is-3-desktop is-3-tablet is-4-mobile">
          <StatsLabel>Trainer</StatsLabel>
          <LabelValue>{get('name', trainer) || '-'}</LabelValue>
        </div>
        {playerInfo.map(({ label, key }) => (
          <div className="column is-3-desktop is-3-tablet is-4-mobile" key={key}>
            <StatsLabel>{label}</StatsLabel>
            <LabelValue>
              {key === 'foaling_date' && get(key, player)
                ? moment().diff(get(key, player), 'years')
                : get(key, player) || '-'}
            </LabelValue>
          </div>
        ))}
      </div>
      <Responsive desktop>
        {isDesktop => {
          let statsData = stats;

          if (isDesktop && Object.keys(stats).length % 2) {
            statsData = { ...stats, ' ': ' ' };
          } else if (!isDesktop && Object.keys(stats).length % 3) {
            statsData = { ...stats, ' ': ' ' };
          }
          return (
            <div className="columns is-mobile is-multiline">
              {Object.entries(statsData).map(([label, value]) => (
                <div
                  className="column is-3-desktop is-4-tablet is-4-mobile"
                  key={label}
                  style={{ padding: 0 }}
                >
                  <TableHeader>{label}</TableHeader>
                  <TableValue>{value || '-'}</TableValue>
                </div>
              ))}
            </div>
          );
        }}
      </Responsive>
    </Wrapper>
  );
};

export default RacingOverview;
